import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { loadBingApi } from "../../api/bingMapsApi"
import $ from 'jquery';

const RouteViewerBingControl = ({
    route,
    user,
    state,
    onShowPoint,
    onHidePoint,
    onZoomChanged,
    onCenterChanged,
    visiblePoint
}) => {


    const mapRef = useRef(null);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);
    const distanceUnit = user.preferredMeasurementUnits == 'Statute' ? 'mi' : 'km';
    const elevationUnit = user.preferredMeasurementUnits == 'Statute' ? 'ft' : 'm';
    const [microsoft, setMicrosoft] = useState(null);
    var map;

    useEffect(() => {
        loadBingApi().then((ms) => {
            setMicrosoft(ms);
        });
    }, []);

    useEffect(() => {
        if (microsoft) {
            setUpMap();
            loadRoute();
        }
    }, [microsoft])

    useEffect(() => {
        if (microsoft) {
            if (visiblePoint) {
                if (visiblePoint.state === "show") {
                    visiblePoint.marker.setOptions({ icon: '/resources/images/routespot.png' });
                    return
                }
                visiblePoint.marker.setOptions({ icon: '/resources/images/routespot_blank.png' });
            }
        }
    }, [visiblePoint])

    function setUpMap() {
        map = new microsoft.Maps.Map(mapRef.current,
            {
                credentials: "AlcdeD51Jzcz_FNPntnbpLZ9KCFoGdwLXBOAFza7A_H6r-v_Mbi8DzoWccMWeZjp",
                mapTypeId: microsoft.Maps.MapTypeId.ordnanceSurvey,
                showZoomButtons: false,
                showLocateMeButton: false,
                showMapTypeSelector: false
            });

        map.setView({ center: new microsoft.Maps.Location(state.center.lat, state.center.lng), zoom: state.zoom });

        microsoft.Maps.Events.addHandler(map, 'viewchangeend', handleMapMove);

        var zoomIn = zoomInRef.current;
        $(zoomIn).unbind('click');
        $(zoomIn).click(() => {
            let zoom = map.getZoom();
            zoom = zoom + 1
            map.setView({ zoom: zoom });
            onZoomChanged(zoom);
        })

        var zoomOut = zoomOutRef.current;
        $(zoomOut).unbind('click');
        $(zoomOut).click(() => {
            let zoom = map.getZoom();
            zoom = zoom - 1
            map.setView({ zoom: zoom });
            onZoomChanged(zoom);
        })
    }

    function handleMapMove() {
        var mapCentre = map.getCenter();
        onCenterChanged({ lat: mapCentre.latitude, lng: mapCentre.longitude });
        var mapZoom = map.getZoom();
        onZoomChanged(mapZoom);
    }

    function loadRoute() {
        if (route.routeId) {

            var path = [];

            var startMarker = new microsoft.Maps.Pushpin(new microsoft.Maps.Location(route.points[0].latitude, route.points[0].longitude),
                {
                    draggable: true,
                    icon: '/resources/images/start-marker.png',
                    width: 29,
                    height: 50,
                    anchor: new microsoft.Maps.Point(25, 47)
                });
            map.entities.push(startMarker);

            route.points.map((point, id) => {

                var latlng = new microsoft.Maps.Location(point.latitude, point.longitude);
                latlng.distanceAtPoint = point.distanceAtPoint;

                var infoboxTemplate = `<div class="bing-infobox infobox"><ul><li>Distance: <b>${point.distanceAtPoint.toFixed(2)}</b> ${distanceUnit}</li><li>Elevation: <b>${point.elevationAtPoint.toFixed(0)}</b> ${elevationUnit}</li></ul></div>`;
                var infobox = new microsoft.Maps.Infobox(latlng,
                    {
                        htmlContent: infoboxTemplate,
                        showCloseButton: false,
                        visible: false
                    });

                infobox.setMap(map);

                point.distanceMarker = new microsoft.Maps.Pushpin(latlng,
                    {
                        draggable: true,
                        icon: '/resources/images/routespot_blank.png',
                        width: 8,
                        height: 8,
                        anchor: new microsoft.Maps.Point(4, 4)
                    });

                microsoft.Maps.Events.addHandler(point.distanceMarker, 'mouseover', function (e) {
                    e.target.setOptions({ icon: '/resources/images/routespot.png' });
                    infobox.setOptions({ visible: true });

                    var location = e.target.getLocation();
                    route.points.map((point) => {
                        if (point.latitude === location.latitude && point.longitude === location.longitude) {
                            showPointDetails(point)
                        }
                    });
                });

                microsoft.Maps.Events.addHandler(point.distanceMarker, 'mouseout', function (e, point) {
                    e.target.setOptions({ icon: '/resources/images/routespot_blank.png' });
                    infobox.setOptions({ visible: false });

                    hidePointDetails();
                });

                map.entities.push(point.distanceMarker);

                path.push(latlng)
            });

            var polyLine = new microsoft.Maps.Polyline(path, { strokeColor: '#3762AD', strokeThickness: 3 });
            map.entities.push(polyLine);
        }
    }

    function showPointDetails(e) {
        onShowPoint(e)
    }

    function hidePointDetails(e) {
        onHidePoint();
    }

    return (
        <div className="bing-container">
            <div className="zoom-controls btn-group" role="group">
                <button ref={zoomInRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-plus" /></button>
                <button ref={zoomOutRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-minus" /></button>
            </div>
            <div ref={mapRef} id="bing-map"></div>
        </div>
    );
}

RouteViewerBingControl.propTypes = {
    route: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    onShowPoint: PropTypes.func,
    onHidePoint: PropTypes.func,
    onZoomChanged: PropTypes.func,
    onCenterChanged: PropTypes.func,
    visiblePoint: PropTypes.object
}

export default RouteViewerBingControl;




// WEBPACK FOOTER //
// ./src/components/routes/RouteViewerBingControl.js